import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Alert from '~/common/componentMapper/Alert/Alert';
import Stack from '~/common/components/Stacks/Stack';
import Link from '~/common/mui/Link';

import ProcessedText from './utilityComponents/ProcessedText';

export default function AlertContainer({ resolution }) {
  const linkLabel = resolution?.link?.label;
  const linkUrl = resolution?.link?.href;
  return (
    <Alert
      {...resolution}
      severity={resolution?.severity ?? 'info'}
      sx={{ ...resolution?.sx, marginTop: '1rem' }}
      message={
        <Stack sx={{ direction: 'row', gap: 1, alignItems: 'center' }}>
          {resolution?.message && (
            <ProcessedText
              text={resolution.message}
              placeholders={resolution.placeholders}
            >
              &nbsp;
              {linkLabel && linkUrl && (
                <Link
                  data-testid="viewSnippet"
                  href={linkUrl}
                  target="_blank"
                  sx={{
                    gap: 1,
                    display: 'inline-flex',
                    alignItems: 'center',
                    lineHeight: 1,
                  }}
                >
                  {linkLabel}
                  <FontAwesomeIcon
                    icon={faExternalLinkAlt}
                    style={{ marginBottom: '4px' }}
                  />
                </Link>
              )}
            </ProcessedText>
          )}
        </Stack>
      }
    />
  );
}
